(function ($) {





// Variables
// -----------------------------------------------------------------------------

	/* global document, window, LazyLoad, jQuery, getComputedStyle, barba, gsap,
	bodyScrollLock, Lenis, ajaxPostLoad, ScrollTrigger, Carousel, Fancybox,
	Autoplay, wpcf7, wpcf7cf, navigator */

	// window.matchMedia("(max-width: 700px)")
	const documentBodyStyle = getComputedStyle(document.body);
	const lgBreakpoint = documentBodyStyle.getPropertyValue("--lg-breakpoint");

	const pageTransitionOut = 0.5;
	const pageTransitionIn = 1.5;
	const pageTransitionSlide = 1;
	const inviewDelay = 150;
	const easeSlide = "power3.inOut";

	const shortTransition = 0.3;
	const longTransition = 0.5;

	let lenis;
	let lazyLoadInstance;
	let currentContainer = $(".js-main");

	let filtersOpenTimeout;

	let windowTop = $(window).scrollTop();
	let windowHeight = window.innerHeight;
	let windowWidth = document.documentElement.clientWidth;
	let previousWindowWidthForHeight = 0;





// Init Lazy Load
// -----------------------------------------------------------------------------

	function initLazyLoad() {
		lazyLoadInstance = new LazyLoad({
			elements_selector: ".js-lazy",
		});
	}





// Set Variables in JS
// -----------------------------------------------------------------------------

	function setScrollbarWidthVariable() {
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		document.documentElement.style.setProperty("--scrollbar", `${scrollbarWidth}px`);
	}

	function set100VHVariable() {
		if (windowWidth !== previousWindowWidthForHeight) {
			previousWindowWidthForHeight = windowWidth;
			document.documentElement.style.setProperty("--vh", `${windowHeight}px`);
		}
	}




// Function to detect if device is a touch device
// -----------------------------------------------------------------------------

	function isTouchDevice() {
		return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
	}




// Scroll to Section
// -----------------------------------------------------------------------------

	function scrollToEl(element, duration, offset = 0) {
		const elementOffset = element.offset().top + 2 - offset;

		$("html, body").animate({
			scrollTop: elementOffset,
		}, duration);
	}





// Scroll Smoother (Lenis)
// -----------------------------------------------------------------------------

	function initLenis() {
		lenis = new Lenis();

		lenis.on("scroll", ScrollTrigger.update);

		gsap.ticker.add((time) => {
			lenis.raf(time * 1000);
		});

		gsap.ticker.lagSmoothing(0);
	}

	function resizeLenis() {
		lenis.resize();
	}





// Hero Scroll Trigger
// -----------------------------------------------------------------------------

	function heroScrollTrigger() {
		if (currentContainer.find(".js-hero-section").length === 0) return;

		const hero = currentContainer.find(".js-hero-section");
		const heroImage = $(hero).find(".js-hero-image img");

		const heroTl = gsap.timeline();

		heroTl.to(heroImage, { y: "25vh", duration: 1, ease: "none" });

		const scrollTriggerOptions = {
			animation: heroTl,
			trigger: hero,
			start: "top top",
			end: "bottom top",
			pin: false,
			pinSpacing: false,
			scrub: true,
			invalidateOnRefresh: true,
		};

		ScrollTrigger.create(scrollTriggerOptions);
	}




// Footer Scroll Trigger
// -----------------------------------------------------------------------------

	function getOverlap(element) {
		const overlapValue = Math.min(windowHeight, element.offsetHeight);
		return overlapValue;
	}

	function adjustOverlap(element) {
		$(element).css("margin-top", `${-getOverlap(element)}px`);
	}

	function footerScrollTrigger() {
		if (currentContainer.find(".js-footer").length === 0) return;

		const mm = gsap.matchMedia();

		mm.add(`(min-width: ${lgBreakpoint})`, () => {
			const panel = $(currentContainer).find(".js-footer").get(0);
			const panelInside = $(currentContainer).find(".js-footer-inside").get(0);
			adjustOverlap(panel);

			ScrollTrigger.create({
				trigger: panel,
				animation: gsap.fromTo(
					panelInside,
					{ yPercent: 50 },
					{ yPercent: 0, ease: "none" },
				),
				start: () => `top ${windowHeight - getOverlap(panel)}`,
				end: () => `+=${getOverlap(panel)}`,
				pin: true,
				pinSpacing: true,
				scrub: true,
				invalidateOnRefresh: true,
			});
		});
	}



// Resize Functions
// -----------------------------------------------------------------------------

	function resizeFunctions() {
		lazyLoadInstance.update();
		resizeLenis();
		setScrollbarWidthVariable();
		set100VHVariable();
		ScrollTrigger.refresh();
	}





// Open Menu
// -----------------------------------------------------------------------------

	function unlockBody() {
		if (!$("html").hasClass("is-locked")) return;

		$("html").removeClass("is-locked");
		document.documentElement.style.setProperty("--compensate-scrollbar", "0px");
		bodyScrollLock.clearAllBodyScrollLocks();
		lenis.start();
	}

	function lockBody(scroll = $(".js-nav").get(0)) {
		if ($("html").hasClass("is-locked")) return;

		$("html").addClass("is-locked");
		lenis.stop();
		// Lock Body Scroll
		setScrollbarWidthVariable();
		bodyScrollLock.disableBodyScroll(scroll, {
			reserveScrollBarGap: false,
		});
		document.documentElement.style.setProperty("--compensate-scrollbar", documentBodyStyle.getPropertyValue("--scrollbar"));
	}

	function openMenu() {
		if ($("html").hasClass("is-menu-open")) return;

		$("html").addClass("is-menu-open is-menu-loading");
		lockBody();
	}

	function closeMenu() {
		if (!$("html").hasClass("is-menu-open")) return;

		$("html").removeClass("is-menu-open");
		setTimeout(() => {
			unlockBody();
			$("html").removeClass("is-menu-loading");
		}, pageTransitionSlide * 1000);
	}

	function closeMenuNoUnlock() {
		if (!$("html").hasClass("is-menu-open")) return;

		$("html").removeClass("is-menu-open");
		setTimeout(() => {
			$("html").removeClass("is-menu-loading");
		}, pageTransitionSlide * 1000);
	}

	function toggleMenu() {
		$(".js-burger").click((event) => {
			event.preventDefault();
			if ($("html").hasClass("is-menu-open")) {
				closeMenu();
			} else {
				openMenu();
			}
		});
	}





// Program Change
// -----------------------------------------------------------------------------

	function programChange() {
		$(".js-program-button").unbind().click(function (event) {
			event.preventDefault();
			const thisProgram = $(this).data("program");
			$(".js-program-button").removeClass("is-active");
			$(this).addClass("is-active");
			const programWrapperHeight = $(".js-program-wrapper").outerHeight();
			$(".js-program-wrapper").css("height", programWrapperHeight);

			if (!window.matchMedia(`(min-width: ${lgBreakpoint})`).matches) {
				scrollToEl($(".js-program-wrapper"), longTransition * 1000, $(".js-program-header").outerHeight());
			}


			gsap.to($(".js-program-wrapper"), {
				opacity: 0,
				duration: shortTransition,
				onComplete: () => {
					$(".js-program-unit").not(`[data-program='${thisProgram}']`).hide(0);
					$(`.js-program-unit[data-program='${thisProgram}']`).show(0);
					const newProgramWrapperHeight = $(`.js-program-unit[data-program='${thisProgram}']`).outerHeight();

					gsap.to($(".js-program-wrapper"), {
						height: newProgramWrapperHeight,
						duration: longTransition,
						ease: easeSlide,
						onComplete: () => {
							resizeFunctions();
							gsap.to($(".js-program-wrapper"), {
								opacity: 1,
								duration: shortTransition,
							});
						},
					});
				},
			});
		});
	}





// Cookie Functions
// -----------------------------------------------------------------------------

	function setCookie(name, value, days) {
		const date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		const expires = `expires=${date.toUTCString()}`;
		document.cookie = `${name}=${value};${expires};path=/`;
	}

	function getCookie(name) {
		const cookieName = `${name}=`;
		const decodedCookie = decodeURIComponent(document.cookie);
		const cookieArray = decodedCookie.split(";");

		for (let i = 0; i < cookieArray.length; i += 1) {
			let cookie = cookieArray[i];
			while (cookie.charAt(0) === " ") {
				cookie = cookie.substring(1);
			}
			if (cookie.indexOf(cookieName) === 0) {
				return cookie.substring(cookieName.length, cookie.length);
			}
		}
		return "";
	}





// Modal Toggle
// -----------------------------------------------------------------------------

	function closeModal() {
		$("html").removeClass("is-search-open is-pdf-open is-newsletter-open is-modal-open is-popup-open");
		setTimeout(() => {
			unlockBody();
			$("html").removeClass("is-modal-loading");
		}, pageTransitionSlide * 1000);
	}

	function modalToggle() {
		$(".js-modal-toggle").unbind().click(function (event) {
			event.preventDefault();
			const modal = $(this).data("modal");

			if ($("html").hasClass(`is-${modal}-open`)) {
				closeModal();
			} else {
				closeMenuNoUnlock();
				$("html").addClass(`is-modal-open is-${modal}-open is-modal-loading`);
				lockBody($(`.js-modal-${modal}`).get(0));
			}
		});
	}

	function openPopupOnLoad() {
		if ($(".js-modal-popup").length && !getCookie("popup_shown")) {
			setTimeout(() => {
				$("html").addClass("is-popup-open is-modal-open is-modal-loading");
				lockBody($(".js-modal-popup").get(0));
				setCookie("popup_shown", "true", 1);
			}, 2000);
		}
	}





// FAQ Toggle
// -----------------------------------------------------------------------------

	function faqToggle() {
		$(".js-faq-toggle").unbind().click(function (event) {
			event.preventDefault();
			const thisFaq = $(this).parent();
			const thisAnswer = thisFaq.find(".js-faq-answer");
			$(".js-faq-answer").not(thisAnswer).slideUp(longTransition * 1000);
			$(".js-faq-line").not(thisFaq).removeClass("is-open");
			thisAnswer.slideToggle(longTransition * 1000, () => {
				resizeFunctions();
			});
			thisFaq.toggleClass("is-open");
		});
	}





// Init Carousels
// -----------------------------------------------------------------------------

	function changeQuotesImage(index) {
		$(".js-quotes-image").removeClass("is-active");
		$(`.js-quotes-image[data-slide='${index}']`).addClass("is-active");
	}

	function initCarousels() {
		if (currentContainer.find(".js-carousel").length === 0) return;

		currentContainer.find(".js-carousel").each(function () {
			const quotesCarousel = $(this).hasClass("js-quotes-carousel");
			const adventureCarousel = $(this).hasClass("js-adventure-carousel");
			const homeCarousel = $(this).hasClass("js-home-carousel");
			const centerMode = quotesCarousel;
			const thisAutoplay = quotesCarousel ? { timeout: 5000, pauseOnHover: false } : false;
			const thisTransition = adventureCarousel ? "fade" : "slide";
			const thisBreakpoints = homeCarousel ? {
				"(min-width: 1816px)": {
					center: true,
				},
			} : false;


			const options = {
				infinite: true,
				transition: thisTransition,
				slidesPerPage: 1,
				center: centerMode,
				Dots: false,
				Autoplay: thisAutoplay,
				breakpoints: thisBreakpoints,
				on: {
					ready: (carousel) => {
						resizeFunctions();
						if (quotesCarousel) {
							changeQuotesImage(carousel.page);
						}
					},
					change: (carousel) => {
						if (quotesCarousel) {
							changeQuotesImage(carousel.page);
						}
					},
				},
			};

			new Carousel(this, options, { Autoplay }); // eslint-disable-line
		});
	}





// Language Switcher
// -----------------------------------------------------------------------------

	function languageSwitcher() {
		$(".js-language-switcher").hover(function () {
			$(this).find(".js-language-dropdown").addClass("is-visible");
		}, function () {
			$(this).find(".js-language-dropdown").removeClass("is-visible");
		});
	}




// Load Forms
// -----------------------------------------------------------------------------

	function onCampaignFormSubmit() {
		let hasRedirected = false;
		const formRedirect = $(".js-pdf-toggle").attr("href");
		const agency = $(".js-modal-pdf").find("input[name='agency']").val();
		setCookie(`${agency}-pdf`, true, 365);

		if (hasRedirected === false) {
			hasRedirected = true;
			const newWindow = window.open(formRedirect, "_blank");
			if (newWindow) {
				newWindow.focus();
			}
			location.reload(); // eslint-disable-line
			window.scrollTo(0, 0);
		}
	}

	function campaignForms() {
		if ($(".js-modal-pdf").length) {
			const agency = $(".js-modal-pdf").data("agency");
			const adventure = window.location.href;
			$(".js-modal-pdf .js-hidden-agency input").val(agency);
			$(".js-modal-pdf .js-hidden-adventure input").val(adventure);

			$(".js-modal-pdf").get(0).removeEventListener("wpcf7mailsent", onCampaignFormSubmit, false);
			$(".js-modal-pdf").get(0).addEventListener("wpcf7mailsent", onCampaignFormSubmit, false);
		}
	}

	function loadForms() {
		const formSelector = "div.wpcf7 > form";
		const forms = $(currentContainer).find(formSelector);
		if (forms.length > 0) {
			$(formSelector).each(function () {
				const form = $(this);
				wpcf7.init(form[0]);
				wpcf7cf.initForm(form);
			});
		}
	}





// In View
// -----------------------------------------------------------------------------

	function addInView(loadingElement, loadingIndex) {
		if (loadingElement.hasClass("is-loading")) return;

		loadingElement.addClass("is-loading");
		setTimeout(() => {
			loadingElement.addClass("is-loaded");
			loadingElement.removeClass("is-loading");

		}, inviewDelay * (loadingIndex));
	}

	function inView() {
		const loadItems = $(".js-inview:visible").not(".is-loaded, .is-loading");
		let stoppedAt = 0;

		loadItems.each(function (loadItemIndex) {
			const loadItem = $(this);
			const loadItemTop = loadItem.offset().top;

			if (windowTop + windowHeight > loadItemTop) {
				if (windowTop - windowHeight / 2 > loadItemTop) {
					loadItem.addClass("is-loaded");
					loadItem.removeClass("is-loading");
					stoppedAt = loadItemIndex;
					return;
				}
				addInView(loadItem, loadItemIndex - stoppedAt);
			}
		});
	}





// Init Selectric
// -----------------------------------------------------------------------------

	function initSelectric() {
		$(".js-select, .js-forms select").each(function () {
			$(this).selectric({
				expandToItemText: true,
				onInit: (currItem) => {
					$(currItem).parent().parent().find(".selectric-input")
						.wrap("<label class='o-text-hidden'>Select Toggle</label>");
					$("input.selectric-input").attr("readonly", true);

				},
				optionsItemBuilder: "<span>{text}</span>",
			});
		});
	}





// Mobile Filters Toggle
// -----------------------------------------------------------------------------

	function closeFilters() {
		$("html").removeClass("is-filters-open");
		filtersOpenTimeout = setTimeout(() => {
			unlockBody();
			$("html").removeClass("is-filters-loading");
		}, (((pageTransitionSlide / 3) * 2) * 1000));
	}

	function mobileFiltersToggle() {
		$(".js-filters-toggle").unbind().click(function (event) { // eslint-disable-line
			event.preventDefault();
			if ($("html").hasClass("is-filters-open")) {
				closeFilters();
			} else {
				clearTimeout(filtersOpenTimeout);
				lockBody($(".js-filters-list"));
				$("html").addClass("is-filters-open is-filters-loading");

			}
		});
	}





// On Overlay Click
// -----------------------------------------------------------------------------

	function onOverlayClick() {
		$(".js-overlay, .js-modal").unbind().click(function (event) { // eslint-disable-line
			if (event.target !== this) return;
			event.preventDefault();
			if ($("html").hasClass("is-filters-open")) {
				closeFilters();
			} else if ($("html").hasClass("is-menu-open")) {
				closeMenu();
			} else if ($("html").hasClass("is-modal-open")) {
				closeModal();
			}
		});
	}





// Fancybox
// -----------------------------------------------------------------------------

	function initFancybox() {
		Fancybox.bind("[data-fancybox]", {
			autoFocus: false,
			placeFocusBack: false,
			mainClass: "o-popup",
			contentClick: false,
			hideScrollbar: false,
			dragToClose: false,
			tpl: {
				closeButton: "<button data-fancybox-close class='f-button is-close-btn' title='{{CLOSE}}'><span class='f-button__inside'><span></span><span></span></span></button>",
			},
			on: {
				init: () => {
					if (!isTouchDevice()) {
						lockBody();
					}
				},
				destroy: () => {
					if (!isTouchDevice()) {
						unlockBody();
					}
				},
			},
		});
	}





// Content Filters
// -----------------------------------------------------------------------------

	function resultCount() {
		if (!$(currentContainer).find(".js-result-count-value").length) return;

		const resultCountValue = $(currentContainer).find(".js-result-count-value");
		const resultCountText = $(currentContainer).find(".js-result-count-text");
		const resultCountValueHTML = resultCountValue.html();
		resultCountText.html(resultCountValueHTML);

		if (resultCountText.css("opacity") === "0") {
			gsap.to(resultCountText, {
				opacity: 1,
				duration: longTransition,
			});
		}
	}

	function resetFilters() {
		$("select.js-filter").each(function () {
			$(this).val($(this).find("option:first").val());
		});
		$(".js-select").selectric("refresh");

		$("input.js-filter").val("");
		if ($("html").hasClass("is-filters-open")) {
			closeFilters();
		}
	}

	function contentAJAX(values) {
		const query = $.param(values);
		const queryString = query ? `?${query}` : "";
		const currentDomain = window.location.origin;
		const currentPath = window.location.pathname;
		const currentURL = currentDomain + window.location.pathname + queryString;

		barba.history.add(currentURL, "barba", "push");
		barba.D.current.url.href = currentURL;
		barba.D.current.url.path = currentPath;
		barba.D.current.url.query = values;

		$("html").addClass("is-loading");
		gsap.to($(".js-ajax-content, .js-result-count-text"), {
			opacity: 0,
			duration: shortTransition,
			callback: () => {
				$.ajax({
					type: "POST",
					url: ajaxPostLoad.ajaxurl,
					dataType: "html",
					data: {
						action: "filter_content",
						values: values, // eslint-disable-line
					},
					success: (res) => {
						const parsedResult = JSON.parse(res);
						$(".js-ajax-content").html(parsedResult.html);
						$("html").removeClass("is-loading");
						gsap.to($(".js-ajax-content"), {
							opacity: 1,
							duration: longTransition,
						});
						if (!window.matchMedia(`(min-width: ${lgBreakpoint})`).matches) {
							scrollToEl($(".js-ajax-wrapper"), longTransition * 1000);
						}
						contentFilters(); // eslint-disable-line
						resultCount();
						resizeFunctions();
					},
					error: () => {
						window.location.href = currentURL;
					},
				});
			},
		});
	}

	function contentFilters() {
		$(".js-filter").unbind().on("change", (event) => {
			event.preventDefault();

			let hasFilter = false;
			const postType = $(".js-ajax-content").data("post-type");
			const values = {
				type: postType,
			};
			$(".js-filter").each(function () {
				const thisTerm = $(this).val();
				const thisTax = $(this).attr("name");
				if (thisTerm !== "*" && thisTerm !== "" && $(this).find("[data-default='yes']").val() !== thisTerm) {
					values[thisTax] = thisTerm;
					if (thisTax !== "view") {
						hasFilter = true;
					}
				}
			});

			if (hasFilter) {
				$(".js-clear-filters").removeClass("is-hidden");
				$(".js-filters-toggle").addClass("is-active");
			} else {
				$(".js-clear-filters").addClass("is-hidden");
				$(".js-filters-toggle").removeClass("is-active");
			}
			contentAJAX(values);
		});

		$(".js-clear-filters").unbind().click(function (event) { // eslint-disable-line
			event.preventDefault();
			resetFilters();
			const postType = $(".js-ajax-content").data("post-type");
			const values = {
				type: postType,
			};
			$(".js-clear-filters").addClass("is-hidden");
			$(".js-filters-toggle").removeClass("is-active");
			contentAJAX(values);

		});
	}





// Page Load Functions
// -----------------------------------------------------------------------------

	function pageReadyFunctions(container) {
		currentContainer = $(container);
		lazyLoadInstance.update();
		inView();
		resultCount();
		initSelectric();
		contentFilters();
		mobileFiltersToggle();
		onOverlayClick();
		heroScrollTrigger();
		initCarousels();
		footerScrollTrigger();
		programChange();
		modalToggle();
		faqToggle();
	}

	function pageLoadFunctions(container) {
		currentContainer = $(container);
		lazyLoadInstance.update();
		inView();
		setScrollbarWidthVariable();
		initFancybox();
		resizeFunctions();
		campaignForms();
	}





// Barba
// -----------------------------------------------------------------------------

	function barbaInit() {
		barba.init({
			debug: false,
			cacheIgnore: true,
			timeout: 5000,
			transitions: [{
				name: "opacity-transition",
				sync: false,
				beforeLeave() {
					$("html").addClass("is-loading");
					closeMenuNoUnlock();
					lockBody();
					Fancybox.close();
					lenis.stop();
				},
				leave(data) {
					const done = this.async();

					const headerHeight = $(".js-header").outerHeight();

					if (windowTop > headerHeight) {
						$("html").addClass("header-is-hidden");
						gsap.to($(".js-header"), {
							opacity: 0,
							duration: pageTransitionOut,
						});
					}

					// Animate Loader
					if (!window.matchMedia(`(min-width: ${lgBreakpoint})`).matches) {
						gsap.fromTo($(".js-loader"), {
							opacity: 1,
							scaleY: 1,
							scaleX: 1,
							xPercent: -100,
						}, {
							xPercent: -70,
							duration: pageTransitionOut,
						});
					}

					return gsap.to(data.current.container, {
						opacity: 0,
						duration: pageTransitionOut,
						onComplete: () => {
							$(data.current.container).css("display", "none");
							done();
						},
					});
				},
				enter(data) {
					const done = this.async();
					$(data.next.container).css("opacity", "0");

					$("html").removeClass("is-loading");
					unlockBody();

					// Scroll to Top unless back button
					if (data.trigger.href !== undefined) {
						window.scrollTo(0, 0);
					}

					if ($("html").hasClass("header-is-hidden")) {
						$("html").removeClass("header-is-hidden");
						gsap.fromTo($(".js-header"), { opacity: 0 }, {
							opacity: 1,
							duration: pageTransitionIn,
						});
					}

					// Animate Loader
					if (!window.matchMedia(`(min-width: ${lgBreakpoint})`).matches) {
						gsap.to($(".js-loader"), {
							xPercent: 0,
							duration: pageTransitionIn,
							onComplete: () => {
								gsap.to($(".js-loader"), {
									scaleY: 0,
									duration: pageTransitionOut,
									onComplete: () => {
										$(".js-loader").css("opacity", "0");
									},
								});
							},
						});
					}

					return gsap.fromTo(data.next.container, { opacity: 0 }, {
						opacity: 1,
						duration: pageTransitionIn,
						onComplete: () => {
							done();
						},
					});
				},
			}],
		});
	}

	barba.hooks.leave(() => {
	});

	barba.hooks.beforeEnter((data) => {
		// Add New Classes to Body
		const nextClass = $(data.next.container).data("barba-class");
		$("body").removeClass();
		$("body").addClass(nextClass);

		// Change Active Menu Item
		const nextNamespace = data.next.namespace;
		$(".menu-item").removeClass("current_page_item current-menu-item");
		$(`.menu-item.${nextNamespace}`).addClass("current_page_item current-menu-item");

		// Update Language Switcher
		$(".js-language").each(function () {
			const thisLanguage = $(this).data("language");
			const newUrl = $(data.next.container).data(thisLanguage);
			$(this).attr("href", newUrl);
		});

		// Scroll to Top unless back button
		if (data.trigger.href !== undefined) {
			window.scrollTo(0, 0);
		}

		// Trigger Functions Needed on all Pages
		pageReadyFunctions(data.next.container);
	});

	barba.hooks.after((data) => {
		pageLoadFunctions(data.next.container);
		loadForms();
		// ga("set", "page", window.location.pathname);
		// ga("send", "pageview");
	});





// Init
// -----------------------------------------------------------------------------

	$(document).ready(() => {
		currentContainer = $(".js-main");
		windowTop = document.documentElement.scrollTop;
		windowHeight = window.innerHeight;
		windowWidth = document.documentElement.clientWidth;
		window.history.scrollRestoration = "manual";

		initLazyLoad();
		setScrollbarWidthVariable();
		set100VHVariable();
		barbaInit();
		toggleMenu();
		initLenis();
		languageSwitcher();
		openPopupOnLoad();
		pageLoadFunctions(currentContainer);
	});

	$(window).on("scroll", () => {
		windowTop = document.documentElement.scrollTop;

		if (!$("html").hasClass("is-loading")) {
			inView();
		}
	});

	$(window).on("resize", () => {
		windowHeight = window.innerHeight;
		windowWidth = document.documentElement.clientWidth;
		setScrollbarWidthVariable();
	});

}(jQuery));
